"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticCountdownTimer = void 0;

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

var _svgs = require("../../svgs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// FIXME: Consider switching from Moment.js to a lighter library like Luxon
// https://moment.github.io/luxon
var FIVE_HOURS_IN_SECONDS = 60 * 60 * 5;

var StaticCountdownTimer = function StaticCountdownTimer(_ref) {
  var action = _ref.action,
      note = _ref.note,
      countdownEnd = _ref.countdownEnd,
      countdownStart = _ref.countdownStart,
      currentTime = _ref.currentTime;
  var actionDeadline = (0, _momentTimezone.default)(countdownEnd).tz(_momentTimezone.default.tz.guess()).format("MMM DD, h:mm A z");
  var highlight = (0, _momentTimezone.default)(countdownEnd).diff((0, _momentTimezone.default)(currentTime), "seconds") < FIVE_HOURS_IN_SECONDS ? "red100" : "purple100";
  return _react.default.createElement(_.StackableBorderBox, {
    flexDirection: "column"
  }, _react.default.createElement(_.Flex, {
    justifyContent: "flex-start"
  }, _react.default.createElement(_svgs.TimerIcon, {
    width: "14",
    height: "17",
    fill: highlight,
    style: {
      marginTop: "1.5px"
    }
  }), _react.default.createElement(_.Spacer, {
    mr: "7px"
  }), _react.default.createElement(_.TimeRemaining, {
    countdownEnd: countdownEnd,
    currentTime: currentTime,
    highlight: highlight
  })), _react.default.createElement(_.ProgressBarTimer, {
    countdownStart: countdownStart,
    countdownEnd: countdownEnd,
    currentTime: currentTime,
    highlight: highlight
  }), _react.default.createElement(_.Sans, {
    size: "2",
    weight: "medium",
    color: "black100"
  }, action, " by ", actionDeadline), _react.default.createElement(_.Sans, {
    size: "2",
    color: "black60"
  }, note));
};

exports.StaticCountdownTimer = StaticCountdownTimer;
StaticCountdownTimer.displayName = "StaticCountdownTimer";
//# sourceMappingURL=StaticCountdownTimer.js.map